<template>
    <modal-component @close="close">
        <template v-slot:header>
            <h1>Heads up!</h1>
        </template>
        
        <p class="text-sm">When you hit back, this email is considered reviewed and will be removed from the list of pending items.</p>
        
        <p class="text-sm mt-2">To keep it unreviewed and go back, you can click <strong>Keep unreviewed</strong>.</p>

        <span class="my-2 block border-t border-gray-dark"></span>

        <p class="text-sm text-gray-darker italic">This message will not be shown again.</p>

        <template v-slot:footer>
            <button
                type="submit"
                class="py-2 px-4 rounded-md bg-primary text-white font-bold"
                @click.prevent="submit"
            >
                Got it!
            </button>
        </template>
    </modal-component>
</template>

<script>
export default {
    methods: {
        submit() {
            this.$emit('resolve');
        },
        close() {
            this.$emit('close');
        }
    }
}
</script>